<template>
  <div id="cesium-container" ref="cesiumContainer">
    <div id="blurred-background" v-if="isViewerLoading || loading">
      <v-progress-circular
        id="loading-indicator"
        :size="40"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { CesiumInitialization } from '@/components/ThreeD/CesiumInitialization'
import { AnalyticalOrbit } from '@/components/ThreeD/AnalyticalOrbit'
import { SceneMode, Rectangle, Camera } from 'cesium'
import CesiumTools from '@/components/ThreeD/CesiumTools'

export default {
  name: 'ConstellationHeterogeneousCesiumViewer',
  mixins: [CesiumInitialization, AnalyticalOrbit],

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    traces: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      isViewerLoading: false
    }
  },

  watch: {
    traces: {
      handler: function () {
        this.updateTraces()
      },
      deep: true
    }
  },

  mounted() {
    this.isViewerLoading = true
    this.initializeViewer()
    this.viewer.scene.mode = SceneMode.SCENE2D
    const defaultRectangle = Rectangle.fromDegrees(-180, -90, 180, 90)
    Camera.DEFAULT_VIEW_RECTANGLE = defaultRectangle
    this.viewer.camera.setView({
      destination: defaultRectangle
    })
    this.isViewerLoading = false
    this.initTracesPC()
  },

  methods: {
    updateTraces() {
      this.isViewerLoading = true
      CesiumTools.removePrimitivesFromPC(this.orbitTracesPC)
      this.addAnalyticalTraces(this.traces)
      this.isViewerLoading = false
    }
  }
}
</script>

<style scoped>
#cesium-container {
  position: relative;
  height: 500px;
  width: 100%;
  z-index: 2;
}

#blurred-background {
  background-color: black;
  opacity: 0.5;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 3;
}

#loading-indicator {
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 4;
  display: block;
}
</style>
